import React from 'react';

import { NotificationManager } from '@atlas/core';

import DeclineDocumentPopup from 'common/Notifications/Popups/DeclineDocumentPopup';
import DepositExitPopup from 'components/ClientProfile/PaymentTab/Deposit/DepositExitPopup';
import WithdrawalCodePopup from 'components/ClientProfile/PaymentTab/TransactionHistory/TransactionHistoryTable/WithdrawalCodePopup';
import VerificationPopup from 'components/ClientProfile/Verification/VerificationPopup';
import { DemoPopup } from 'components/DemoPopup/DemoPopup';
import AccountToppedUpPopup from 'src/common/Notifications/Popups/AccountToppedUpPopup';
import CommonSpentLimitPopup from 'src/common/Notifications/Popups/CommonSpentLimitPopup';
import AtlasTransferPopup from 'src/common/Notifications/Popups/Deposit/AtlasTransferPopup';
import LeaveSignupPopup from 'src/common/Notifications/Popups/LeaveSignupPopup';
import PaymentLoadingPopup from 'src/common/Notifications/Popups/PaymentLoadingPopup';
import { PaymentFormErrorPopup } from 'src/common/Notifications/Popups/PaymentsFormPopup/PaymentsFormErrorPopup';
import PaymentsFormPopup from 'src/common/Notifications/Popups/PaymentsFormPopup/PaymentsFormPopup';
import PixDepositResultPopup from 'src/common/Notifications/Popups/PixDepositResultPopup';
import SpeiDepositPopup from 'src/common/Notifications/Popups/SpeiPayment/SpeiDepositPopup';
import SpeiWithdrawalPopup from 'src/common/Notifications/Popups/SpeiPayment/SpeiWithdrawalPopup';
import AtlasTransferWithdrawalPopup from 'src/common/Notifications/Popups/Withdrawal/AtlasTransferPopup';
import WithdrawalInterkassaCardPopup from 'src/common/Notifications/Popups/WithdrawalInterkassaCardPopup';
import WithdrawalInterkassaEuroPopup from 'src/common/Notifications/Popups/WithdrawalInterkassaEuroPopup';
import WithdrawalKushkiPopup from 'src/common/Notifications/Popups/WithdrawalKushkiPopup';
import WithdrawalMagnetarPopup from 'src/common/Notifications/Popups/WithdrawalMagnetarPopup';
import withdrawalPayretailersPopup from 'src/common/Notifications/Popups/WithdrawalPayretailersPopup';
import WithdrawalProntopagaPopup from 'src/common/Notifications/Popups/WithdrawalProntopagaPopup';
import WithdrawalTonderPopup from 'src/common/Notifications/Popups/WithdrawalTonderPopup';
import TerminalPixDepositPopup from 'src/terminal/components/Deposit/Popups/TerminalPixDepositPopup';
import TerminalBankAccountPopup from 'src/terminal/popups/TerminalBankAccountPopup';
import TerminalInitializationPopup from 'src/terminal/popups/TerminalInitializationPopup';
import TerminalLogoutPopup from 'src/terminal/popups/TerminalLogoutPopup';
import TerminalSelfExclusionPopup from 'src/terminal/popups/TerminalSelfExclusionPopup';

import { AccountBlockedPopup } from './Popups/AccountBlockedPopup';
import { AccountNumbersPopup } from './Popups/AccountNumbersPopup';
import AdultPopup from './Popups/AdultPopup';
import { AlternativeMethodsPopup } from './Popups/AlternativeMethodsPopup';
import BitcoinPopup from './Popups/BitcoinPopup';
import BonusActivationSuccessPopup from './Popups/BonusActivationSuccessPopup';
import BonusCancelPopup from './Popups/BonusCancelPopup/BonusCancelPopup';
import BonusConflictPopup from './Popups/BonusConflictPopup/BonusConflictPopup';
import ConfirmationPopup from './Popups/ConfirmationPopup';
import { InstructionPopup } from './Popups/Deposit/InstructionPopup';
import DepositSuccessPopup from './Popups/DepositSuccessPopup/DepositSuccessPopup';
import DetailedPopup from './Popups/DetailedPopup';
import { ErrorPopup } from './Popups/ErrorPopup';
import FinishedBonusDetailsPopup from './Popups/FinishedBonusDetails/FinishedBonusDetailsPopup';
import GPayPopup from './Popups/GPayPopup';
import { IFramePopup } from './Popups/IFramePopup';
import MessagesPopup from './Popups/MessagesPopup';
import MultiPopup from './Popups/MultiPopup/MultiPopup';
import NotificationPopup from './Popups/NotificationPopup';
import OneClickSignUp from './Popups/OneClickSignUp';
import PayMayaPopup from './Popups/PayMayaPopup';
import RealityCheckPopup from './Popups/RealityCheckPopup';
import RealityCheckTimeLimitsPopup from './Popups/RealityCheckTimeLimitsPopup';
import RegistrationBonusPopup from './Popups/RegistrationBonusPopup';
import ResponsibleGamingPopup from './Popups/ResponsibleGamingPopup';
import StarsPayPopup from './Popups/StarsPayPopup';
import StoreItemDetailsPopup from './Popups/StoreItemDetails/StoreItemDetailsPopup';
import StorePurchaseConfirmationPopup from './Popups/StorePurchaseConfirmationPopup';
import { SuccessfulWithdrawalPopup } from './Popups/SuccessfulPaymentPopup';
import SuccessPopup from './Popups/SuccessPopup';
import ToastCard from './Popups/ToastCard';
import TwoFactorLogin from './Popups/TwoFactorLoginPopup';
import { WithdrawalAlfacoinPopup } from './Popups/WithdrawalAlfacoinPopup/WithdrawalAlfacoinPopup';
import { WithdrawalApexpayPopup } from './Popups/WithdrawalApexpayPopup';
import { WithdrawalBitcoinPopup } from './Popups/WithdrawalBitcoinPopup/WithdrawalBitcoinPopup';
import { WithdrawalBitcoinPopupV2 } from './Popups/WithdrawalBitcoinPopup/WithdrawalBitcoinPopupV2';
import { WithdrawalCashdeskPopup } from './Popups/WithdrawalCashdeskPopup/WithdrawalCashdeskPopup';
import { WithdrawalDirectaPopup } from './Popups/WithdrawalDirectaPopup/WithdrawalDirectaPopup';
import { WithdrawalInteracPopup } from './Popups/WithdrawalInteracPopup';
import { WithdrawalInterkassaPopup } from './Popups/WithdrawalInterkassaPopup/WithdrawalInterkassaPopup';
import { WithdrawalPaystackPopup } from './Popups/WithdrawalPaystackPopup';
import { WithdrawalPixNoEvpPopup } from './Popups/WithdrawalPixPopup/WithdrawalPixNoEvpPopup';
import { WithdrawalPixPopup } from './Popups/WithdrawalPixPopup/WithdrawalPixPopup';
import { WithdrawalSanalbankPopup } from './Popups/WithdrawalSanalbankPopup/WithdrawalSanalbankPopup';
import NotificationsPortal from './NotificationsPortal';
import DepositLoadingPopup from './Popups/DepositLoadingPopup';
import ToastStack from './ToastStack';

const NotificationsComponentsMap = {
  WithdrawalPixNoEvp: WithdrawalPixNoEvpPopup,
  // Deposit / Withdraw
  accountBlocked: AccountBlockedPopup,
  accountNumbers: AccountNumbersPopup,
  accountToppedUp: AccountToppedUpPopup,
  // Common popups
  adultPopup: AdultPopup,
  alternativeMethods: AlternativeMethodsPopup,
  atlasTransfer: AtlasTransferPopup,
  atlasTransferWithdrawal: AtlasTransferWithdrawalPopup,
  // Payment methods special popups
  bitcoin: BitcoinPopup,
  bonusActivationSuccess: BonusActivationSuccessPopup,
  bonusCancel: BonusCancelPopup,
  bonusConflict: BonusConflictPopup,
  confirm: ConfirmationPopup,

  // Decline document
  declineDocument: DeclineDocumentPopup,
  demo: DemoPopup,
  depositExitPopup: DepositExitPopup,
  depositInstruction: InstructionPopup,
  depositSuccess: DepositSuccessPopup,
  detailed: DetailedPopup,
  error: ErrorPopup,
  finishedBonusDetails: FinishedBonusDetailsPopup,
  gpay: GPayPopup,
  iframe: IFramePopup,
  leaveSignup: LeaveSignupPopup,
  messages: MessagesPopup,
  multiPopup: MultiPopup,
  notification: NotificationPopup,
  oneClickSignUp: OneClickSignUp,
  paymaya: PayMayaPopup,
  paymentFormError: PaymentFormErrorPopup,
  paymentLoading: PaymentLoadingPopup,
  depositLoading: DepositLoadingPopup,
  paymentsForm: PaymentsFormPopup,
  pix: StarsPayPopup,
  pixDepositResult: PixDepositResultPopup,
  realityCheck: RealityCheckPopup,
  realityCheckTimeLimitsPopup: RealityCheckTimeLimitsPopup,
  registrationBonus: RegistrationBonusPopup,

  // Responsible-gaming popups
  responsibleGaming: ResponsibleGamingPopup,
  speiDeposit: SpeiDepositPopup,
  speiWithdrawal: SpeiWithdrawalPopup,
  spentLimit: CommonSpentLimitPopup,
  storeItemDetails: StoreItemDetailsPopup,
  storePurchaseConfirmation: StorePurchaseConfirmationPopup,
  success: SuccessPopup,
  terminalBankAccount: TerminalBankAccountPopup,

  // terminal popups
  terminalInitialization: TerminalInitializationPopup,
  terminalLogout: TerminalLogoutPopup,
  terminalPixDeposit: TerminalPixDepositPopup,
  terminalSelfExclusion: TerminalSelfExclusionPopup,

  toast: ToastCard,

  // Sign in/up special popups
  twoFactorLogin: TwoFactorLogin,
  verificationPopup: VerificationPopup,

  // Withdraw
  withdrawalAlfacoin: WithdrawalAlfacoinPopup,
  withdrawalApexpay: WithdrawalApexpayPopup,
  withdrawalBitcoin: WithdrawalBitcoinPopup,
  withdrawalBitcoinV2: WithdrawalBitcoinPopupV2,
  withdrawalCashdesk: WithdrawalCashdeskPopup,
  withdrawalCodePopup: WithdrawalCodePopup,
  withdrawalDirectaPopup: WithdrawalDirectaPopup,
  withdrawalInterac: WithdrawalInteracPopup,

  withdrawalInterkassa: WithdrawalInterkassaPopup,

  withdrawalInterkassaCard: WithdrawalInterkassaCardPopup,
  withdrawalInterkassaEuro: WithdrawalInterkassaEuroPopup,

  withdrawalKushki: WithdrawalKushkiPopup,
  withdrawalMagnetar: WithdrawalMagnetarPopup,
  withdrawalPayretailers: withdrawalPayretailersPopup,
  withdrawalPaystack: WithdrawalPaystackPopup,

  withdrawalPix: WithdrawalPixPopup,
  withdrawalProntopaga: WithdrawalProntopagaPopup,

  withdrawalSanalbank: WithdrawalSanalbankPopup,
  withdrawalSuccessful: SuccessfulWithdrawalPopup,

  withdrawalTonder: WithdrawalTonderPopup,
};

const notificationsReducer = (state, action) => {
  switch (action.type) {
    case 'ADD':
      if (state.find(notification => notification.id === action.payload.id)) {
        return state;
      }

      return [...state, action.payload];
    case 'REMOVE':
      return state.reduce((acc, notification) => {
        if (notification.id === action.payload) {
          return acc;
        }

        return [...acc, notification];
      }, []);
    default:
      return state;
  }
};

const initialState = [];

const renderNotification = notificationData => {
  const { type, ...notificationPayload } = notificationData;

  const NotificationComponent = NotificationsComponentsMap[type];

  if (!NotificationComponent) {
    return null;
  }

  return <NotificationComponent key={notificationData.id} {...notificationPayload} />;
};

const Notifications = () => {
  const [notifications, dispatch] = React.useReducer(notificationsReducer, initialState);

  React.useEffect(() => {
    NotificationManager.subscribe(dispatch);

    return () => {
      NotificationManager.unsubscribe(dispatch);
    };
  }, []);

  const { popups, toasts } = React.useMemo(() => {
    const partitioned = { popups: [], toasts: [] };

    notifications.forEach(notification => {
      if (notification.kind === 'toast') {
        partitioned.toasts.push(notification);
      } else {
        partitioned.popups.push(notification);
      }
    });

    return partitioned;
  }, [notifications]);

  React.useEffect(() => {
    document.body.style.overflow = popups.length > 0 ? 'hidden' : null;
  }, [popups.length]);

  const PopupComponents = React.useMemo(() => popups.map(renderNotification), [popups]);

  return (
    <>
      <NotificationsPortal className="notifications-container">
        {PopupComponents}
      </NotificationsPortal>
      <ToastStack items={toasts} renderToast={renderNotification} />
    </>
  );
};

export default Notifications;
